import { env } from '@/app/config/env';

const apiUrl = env.API_URL.replace(/\/$/, '');

export function resolveFormMenuImageUrl(
  url?: string | null,
): string | undefined {
  if (!url) {
    return undefined;
  }

  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('blob:') ||
    url.startsWith('data:')
  ) {
    return url;
  }

  const normalizedPath = url.startsWith('/') ? url : `/${url}`;
  return apiUrl ? `${apiUrl}${normalizedPath}` : normalizedPath;
}
